import {Component, OnInit, ViewChild} from '@angular/core';
import {process, SortDescriptor, State} from '@progress/kendo-data-query';
import {ExcelExportEvent, GridComponent, GridDataResult, PageChangeEvent, RowArgs} from '@progress/kendo-angular-grid';
import {GLItem} from '../../../core/shared/model/GLItem';
import {UserService} from '../../../core/services/user.service';
import {GlguideService} from '../../../core/services/glguide.service';
import {GLGuide} from '../../../core/shared/model/GLGuide';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {GLCode} from '../../../core/shared/model/GLCode';
import {FSInvoiceDialogService} from '../../../core/services/fsinvoice.dialog.service';
import { LoggingService} from 'mclane-apptemplate-lib';
import {ExcelExportData} from '@progress/kendo-angular-excel-export';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';
import { lastValueFrom } from 'rxjs';
const createFormGroup = dataItem => new FormGroup({
  'seq': new FormControl(dataItem.seq),
  'glcode': new FormControl(dataItem.glcode),
  'itemSub': new FormControl(dataItem.itemsub),
  'itemNo': new FormControl(dataItem.itemNo),
  'itemDesc': new FormControl(dataItem.itemDesc)
});


@Component({
  selector: 'app-maintainitem',
  templateUrl: './glmaintainitem.component.html',
  styleUrls: ['./glmaintainitem.component.scss']
})

export class GLMaintainItemComponent implements OnInit {

  public gridState: State = {
    sort: [],
    skip: 0,
    take: 10
  };

  glmaintainitem: Array<GLItem>;
  skip = 0;
  pageSize: number = 30;
  username: string;
  selectedKeys: string[];
  selectedValue: string;
  indexglguide: number;
  glguide: number;
  glguideDescriptions: string[];
  glguides: Array<GLGuide> = new Array<GLGuide>();
  glItems: Array<GLItem> = [];
  glItemsAll: Array<GLItem>;
  glCodes: Array<GLCode>;
  glcategories: string[];
  itemMaintForm: FormGroup;
  selectedCategory: string;
  private editedRowIndex: number;
  public isNew: boolean = true;
  public isEditable: boolean = false;
  public categories: any[] = this.glItems;
  public formGroup: FormGroup;
  categoryChanged: boolean = false;
  private _editedRowIndex: number;
  private _editedColumnIndex: number;
  private _sequence: any;
  private _editedItemCode: GLItem;
  private _itemSub: any;
  public result: any;
  view: GridDataResult;
  scale = 0.7;
  sort: SortDescriptor[] = [{
    field: 'siteName',
    dir: 'asc'
  }];
  @ViewChild(GridComponent)
  private grid: GridComponent;

  constructor(public console: LoggingService,
              private _formBuilder: FormBuilder,
              public userService: UserService,
              public glguideService: GlguideService,
              public loadingIndicator: LoadingIndicatorHelper,
              public dialogService: FSInvoiceDialogService) {
    this.exportAllData = this.exportAllData.bind(this);
  }

  async ngOnInit() {
    this.loadingIndicator.show();

    this.selectedCategory = undefined;
    this.glguideService.setUpdatedItemsNull();

    this.username = this.userService.getUserName();

    await lastValueFrom(this.glguideService.getGLGuideList(this.username))
      .then(async glguides => {
        if (glguides.length > 0) {
          this.glguides = glguides;

          this.userService.setGLGuides(this.glguides);
          this.glguides = this.userService.getGLGuides();
          this.glguideDescriptions = this.glguides.map(a => a.glGuide);

          //defaults to first item in list
          this.selectedValue = this.glguideDescriptions[0];
          this.indexglguide = this.glguides.findIndex(x => x.glGuide = this.selectedValue);

          if (this.glguides[this.indexglguide] !== undefined) {
            this.glguideService.setglguide(this.glguides[this.indexglguide].glGuideId);
            this.glguide = this.glguideService.getglguide();

            await lastValueFrom(this.glguideService.getGLCodes(this.glguides[this.indexglguide].glGuideId))
              .then(async glcodes => {
                this.glCodes = glcodes;

                this.glCodes.forEach(item => {
                    item.codeDescription = item.glCode + " " + item.glDescription;
                  }
                )

                this.glguideService.setCodes(glcodes);
                this.glcategories = this.glCodes.map(a => a.glDescription);

                //new all items call added
                await lastValueFrom(this.glguideService.getAllItems(this.glguide))
                  .then(r => {
                    this.glItemsAll = r;
                  });

                await lastValueFrom(this.glguideService.getItemList(this.glguide))
                  .then(items => {
                    this.glItems = items;
                    this.glguideService.setGLItems(items);
                    this.loadingIndicator.hide();
                  });
              });
          }
        } else {
          this.loadingIndicator.hide()
        }
      });
  }

  pageChange({skip, take}: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  public cellClickHandler({dataItem, rowIndex, isEdited, sender, columnIndex, isNew}): void {
    if (isNew || dataItem.glcode === '9999' || (this.editedRowIndex != undefined && this.editedRowIndex != rowIndex)) {
      return;
    }
    this.isEditable = true;
    this.editedRowIndex = rowIndex;
    this.selectedCategory = this.selectedCategory;
    this.glguideService.setUpdatedItemsNull();

    let prevItem = this.glguideService.getPreviousItemNo();
    if (prevItem) {
      let index = this.glItemsAll.findIndex(item => item.itemNo === prevItem);
      if (index > -1) {
        this.glItemsAll[index].itemSub = this.glguideService.getPreviousCategory();
      }
    }

    this.selectedCategory = dataItem.itemSub;
    this._itemSub = dataItem.itemSub;

    if (!isEdited) {
      this.grid.editRow(rowIndex, this.createFormGroupEdit(dataItem));
    }

    this.glguideService.setPreviousRowIndex(rowIndex);
    this.glguideService.setPreviousCategory(dataItem.itemSub);
    this.glguideService.setPreviousItemNo(dataItem.itemNo);
  }

  private closeEditor(): void {
    this.grid.closeRow(this.editedRowIndex);
    this.isEditable = false;
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  editClicked(event) {
    this.closeEditor();
    this._editedRowIndex = event.rowIndex;
    this._editedItemCode = Object.assign({}, event.dataItem);

    event.sender.editRow(event.rowIndex);
  }


  public createFormGroupEdit(dataItem: any): FormGroup {
    return this._formBuilder.group({
      'itemSub': [this.selectedCategory],

    });
  }

  public createFormGroupAdd(dataItem): FormGroup {
    return this._formBuilder.group({
      'itemNo': dataItem.itemNo
    });
  }

  async addHandler({sender}) {
    this.isNew = true;
    this.isEditable = false;
    sender.addRow(this.createFormGroupAdd(new GLItem()));

    await lastValueFrom(this.glguideService.getNextSeq(this.glguide))
      .then(async res => {
        this._sequence = res;
      });
  }


  public cancelChanges(): void {
    this.ngOnInit().then(r => r);
    this.glguideService.setCategoryChanged(false);
    this.glguideService.cancelChanges();
    this.closeEditor();
  }

  public cancelHandler(event) {
    this.cancelChanges();
  }

  async guideChange(event) {
    this.loadingIndicator.show();
    this.glguideService.glguidedescription = this.selectedValue;
    this.indexglguide = this.glguides.findIndex(x => x.glGuide === this.selectedValue);

    this.glguideService.setglguide(this.glguides[this.indexglguide].glGuideId);
    this.glguide = this.glguides[this.indexglguide].glGuideId;

    await lastValueFrom(this.glguideService.getGLCodes(this.glguides[this.indexglguide].glGuideId))
      .then(async r => {
        this.glCodes = r;

        this.glCodes.forEach(item => {
          item.codeDescription = item.glCode + " " + item.glDescription;
        });

        this.glguideService.setCodes(r);

        // this.glguideService.setCodes(glcodes);
        this.glcategories = this.glCodes.map(a => a.glDescription);

        //new all items call added
        await lastValueFrom(this.glguideService.getAllItems(this.glguide))
          .then(r => {
            this.glItemsAll = r;
          });

        await lastValueFrom(this.glguideService.getItemList(this.glguide))
          .then(items => {
            this.glItems = items;
            this.glguideService.setGLItems(items);
            this.loadingIndicator.hide();
          });
      });
  }

  public async saveChanges(grid, e): Promise<void> {
    this.closeEditor();
    if (this.glguideService.hasChanges()) {
      this.loadingIndicator.show();
      let updatedItems = this.glguideService.getUpdatedItems();
      let updItem = updatedItems[0];
      let category = this.glguideService.getselectedCategory();
      let glCodes = this.glguideService.getCodes();
      let index = this.glCodes.findIndex(x => x.glCode === category);
      let altSeq = glCodes[index].glSequence;

      await lastValueFrom(this.glguideService.updateGLItem(this.glguideService.getglguide(), updItem.itemNo, altSeq, this.userService.getUserName()))
        .then(async results => {
          //this.ngOnInit().then(r => {
          await lastValueFrom(this.glguideService.getAllItems(this.glguide))
            .then(r => {
              this.glItemsAll = r;
            });

          this.clearCategory();

          this.glguideService.reset();
          this.loadingIndicator.hide();

          this.userService.showNotification('Item Successfully Updated', 2000);

        }).catch((error) => {
          console.error(error);
          this.glguideService.reset();
          this.loadingIndicator.hide();
          this.userService.showError('Problem Updating Item', 2000);
        });
    }
  }

  clearCategory() {
    this.glguideService.setUpdatedItemsNull();
    this.glguideService.setPreviousItemNo(undefined);
    this.glguideService.setPreviousCategory('');
    this.selectedCategory = undefined;
  }

  // private closeEditor(grid, rowIndex = this._editedRowIndex, columnIndex = this._editedColumnIndex) {
  //   grid.closeCell(rowIndex, columnIndex);
  //   this._editedColumnIndex = undefined;
  //   this._editedRowIndex = undefined;
  //   this.formGroup = undefined;
  // }

  public async saveHandler(event) {
    this.isEditable = false;
    this.loadingIndicator.show();
    if (event.formGroup.valid) {
      event.sender.closeRow(event.rowIndex);

      this.glguideService.reset();
      this.selectedCategory = this.glguideService.getselectedCategory();
      let glCodes = this.glguideService.getCodes();
      let index = this.glCodes.findIndex(x => x.glCode === this.selectedCategory);
      let sequence = glCodes[index].glSequence;

      await lastValueFrom(this.glguideService.addGLItem(this.glguide, sequence, sequence, event.dataItem.itemNo, this._sequence, this.username))
        .then(r => {
          if (r['status'] === 200) {
            this.ngOnInit().then(r => {
              lastValueFrom(this.glguideService.updateGuideHeader(this._sequence, this.glguide))
                .then(r => {
                  if (r['status'] === 200) {
                    this.loadingIndicator.hide();
                    this.glguideService.reset();
                    this.userService.showNotification('Item Successfully Added', 2000);
                  }
                }).catch((error) => {
                console.error(error);
                this.glguideService.reset()
                this.userService.showError('Problem updading GL header', 2000);
              });
            });
          }
        }).catch((error) => {
          console.error(error);
          this.loadingIndicator.hide();
          this.glguideService.reset();
          this.userService.showError('Problem adding Item', 2000);
        });
    }
  }

  valueChange(value: any, dataItem) {
    if (value === null) {
      return;
    } else {
      dataItem.itemSub = value;

      this.glguideService.setCategoryChanged(true);
      this.categoryChanged = this.glguideService.getCategoryChanged();
      this.glguideService.setselectedCategory(value);
      this.selectedCategory = this.glguideService.getselectedCategory();
      this.glguideService.assignValues(dataItem, value);
      this.glguideService.update(dataItem);

    }
  }

  public category(id: number): any {
    return this.glItems.find(x => x.glcode === id);
  }

  async removeClicked(event) {
    await lastValueFrom(this.dialogService.showYesNoDialog('Remove', 'Are you sure you would like to remove ' + event.dataItem.itemDesc + '?'))
      .then(async res => {
        this.result = res;

        if (this.result == true) {
          this.loadingIndicator.show();
          this.glguide = this.glguideService.getglguide();
          this.glguideService.reset();
          await lastValueFrom(this.glguideService.deleteItem(this.glguide, event.dataItem.seq, event.dataItem.itemNo))
            .then(r => {
              this.ngOnInit().then(r => {
                this.loadingIndicator.hide();
              });
              this.userService.showNotification('Item Successfully Removed', 2000);
              this.cancelChanges();
            }).catch((error) => {
              console.error(error);
              this.loadingIndicator.hide();
              this.userService.showError('Problem Removing Item', 2000);
            });
        } else {
          event.sender.cancelCell();
          this.loadingIndicator.hide();
          this.cancelChanges();
        }
      });
  }

  public onStateChange(state: State) {
    this.selectedCategory = undefined;
    this.glguideService.setUpdatedItemsNull();

    this.gridState = state;
    this.view = process(this.glItems, this.gridState);
    this.glguideService.read1();
  }


  selectionKey(context: RowArgs): string {
    return context.dataItem.id;
  }

  //Excel export
  public exportAllData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.glItems, {}).data,
    };
    return result;
  }

  excelExported($event: ExcelExportEvent) {
    const sheet = $event.workbook.sheets[0];
    sheet.freezePane.rowSplit = 0;
    sheet.name = 'GlmaintainItem';
  }

  exportToExcel(GlmaintainItem: GridComponent) {
    try {
      this.loadingIndicator.show();
      setTimeout(() => {
        GlmaintainItem.saveAsExcel();
        this.loadingIndicator.hide();
      }, 100);
    } catch (ex) {
      this.dialogService.showErrorNotification('There was a problem exporting this worksheet, please try again later');
      this.loadingIndicator.hide();
    }
  }

  //PDF export
  exportToPDF(GlmaintainItem: GridComponent) {
    try {
      this.loadingIndicator.show();
      setTimeout(() => {
        GlmaintainItem.saveAsPDF();
        this.loadingIndicator.hide();
      }, 200);
    } catch (ex) {
      this.dialogService.showErrorNotification('There was a problem exporting this worksheet, please try again later');
      this.loadingIndicator.hide();
    }
  }
}


